<template>
	<div class="news_table">
		<table class="table table-responsive table-hover align-middle">
			<thead>
				<tr class="py-md-2">
					<td>
						{{ $t("newsList.title") }}
					</td>
					<td class="text-center">
						<button class="btn" @click="sortByTime()">
							{{ $t("newsList.time") }}
							<span
								v-if="oldToNew === true"
								class="ts-icon is-sort-down-icon"></span>
							<span v-else class="ts-icon is-sort-up-icon"></span>
						</button>
					</td>
				</tr>
			</thead>

			<tbody>
				<tr
					class="newsLists_item"
					v-for="item in lists.slice(0, 5)"
					:key="item.id"
					data-aos="fade-right"
					data-aos-delay="100"
					data-aos-once="true">
					<td
						v-if="$i18n.locale == 'zh-TW' || item.title_en === ''"
						class="news_content py-3">
						<InertiaLink :href="`/announcements/${item.id}`">
							{{ item.title }}
						</InertiaLink>
					</td>
					<td v-else class="news_content py-3">
						<InertiaLink :href="`/announcements/${item.id}`">
							{{ item.title_en }}
						</InertiaLink>
					</td>
					<td class="news_time text-md-center py-3">
						{{ timeformat(item.created_at) }}
					</td>
				</tr>

				<tr
					class="newsLists_item"
					v-for="item in newlists"
					:key="item.id">
					<td
						v-if="$i18n.locale == 'zh-TW' || item.title_en === ''"
						class="news_content py-3">
						<InertiaLink :href="`/announcements/${item.id}`">
							{{ item.title }}
						</InertiaLink>
					</td>
					<td v-else class="news_content py-3">
						<InertiaLink :href="`/announcements/${item.id}`">
							{{ item.title_en }}
						</InertiaLink>
					</td>
					<td class="news_time text-md-center py-3">
						{{ timeformat(item.created_at) }}
					</td>
				</tr>
				<tr v-if="lists.length === 0">
					<td class="text-center" colspan="2">
						{{ $t("newsList.empty") }}
					</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>

<script>
// import extension
import axios from "axios";
import { format, sub } from "date-fns";

export default {
	data() {
		return {
			lists: [],
			oldToNew: true,
		};
	},
	methods: {
		sortByTime() {
			this.oldToNew = !this.oldToNew;
		},
		timeformat(time) {
			return format(new Date(time), "yyyy/MM/dd");
		},
		getdata() {
			var vm = this;
			axios
				.get("/api/v1/lists")
				.then(function (response) {
					// handle success
					var unsorted_lists = response.data.announcements;
					vm.lists = unsorted_lists;
				})
				.catch(function (error) {
					// handle error
					console.log(error);
				});
		},
	},
	mounted() {
		this.getdata();
	},
	computed: {
		newlists: function () {
			var order = this.oldToNew ? 1 : -1;
			this.lists.sort((a, b) => {
				var results =
					new Date(a.created_at) > new Date(b.created_at)
						? -1
						: new Date(a.created_at) < new Date(b.created_at)
						? 1
						: 0;
				return results * order;
			});
		},
	},
};
</script>

<style scoped>
/* list */
a {
	color: black;
	text-decoration: none;
}

a:hover {
	color: orange;
}

table {
	border-radius: 1px;
	color: #6e460b;
}
table td button {
	color: #6e460b;
}
table thead {
	font-weight: bold;
	font-size: 18px;
}
</style>
